import React from "react";

const AuthFail = props => (
  <div className="error-boundary">
    <div>
      <h1 className="error-boundary-text">
        Ooops! It looks like we don&#39;t have anything to show you here.
      </h1>
      <br />
      {/* <h1 className="error-boundary-title">Please get links to view calls from your team manager!</h1> */}
      <br />
    </div>
    <div>
      <div className="error-boundary-text">
        Return to the <p className="error-boundary-link"  onClick={() => props.history.goBack()}>&nbsp;previous page</p>.
      </div>
    </div>
  </div>
);

export default AuthFail;
